var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal image-gallery-modal new-modal \n    ".concat(_vm.isMobile ? 'image-gallery-modal--mobile' : 'image-gallery-modal--desktop', " \n    ").concat(_vm.zoomLevelHigh ? 'zoom-level-high' : ''),
      "height": _vm.heightModal,
      "width": _vm.widthModal,
      "name": "addYourImageGallery",
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal,
      "beforeClose": _vm.beforeClose,
      "closed": _vm.closeModal
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": ['new-modal-wrapper', 'customs-tools', {
        'new-modal-wrapper__modify': _vm.views[_vm.activeViewIndex] === 'image-gallery-continue-and-edit-view'
      }]
    }
  }, [_c('ModalHeader', {
    attrs: {
      "customClass": "image-gallery-modal-header",
      "includeBack": _vm.isBackButtonVisible,
      "backDisabled": _vm.isPreviewDataLoading,
      "closeDisabled": !_vm.showCloseModal,
      "headerImg": true,
      "modalTitle": _vm.translations.addYourImageGalleryTitle
    },
    on: {
      "backEvent": _vm.goBackAction,
      "closeEvent": _vm.exitLibraryModal
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-main-views-wrapper",
      "elementType": "section"
    }
  }, [_c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLibrarySpinner,
      expression: "showLibrarySpinner"
    }]
  }), _c(_vm.views[_vm.activeViewIndex], {
    tag: "component",
    attrs: {
      "activeViewIndex": _vm.activeViewIndex,
      "gallery": _vm.gallery,
      "selectedImageId": _vm.selectedImageId
    },
    on: {
      "selectImage": _vm.onSelectImage,
      "reloadGallerySizes": _vm.reloadGallerySizes,
      "onCloseModal": _vm.onCloseModal,
      "showCloseIcon": _vm.onShowCloseIcon,
      "isApplyingData": _vm.onDataLoading
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCTAButton,
      expression: "showCTAButton"
    }],
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    staticClass: "new-modal-button-nav-container"
  }, [_c('CustomButton', {
    attrs: {
      "isDisabled": _vm.isPreviewDataLoading,
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "keyTranslation": "ugc-next",
      "type": "button"
    },
    on: {
      "click": _vm.onNextImageSelection
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }